import { cn } from '@jeraisonne/ui';
import type { ExerciseAccessState } from '@/lib/student-objectives/objective-types';

const META = {
  subscription: { label: 'Premium', cls: 'bg-primary-50 text-primary-700 border-primary-200' },
  daily: { label: 'Exercice du jour', cls: 'bg-accent-50 text-accent-700 border-accent-200' },
  class_assignment: {
    label: 'Devoir de classe',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  tutor_assignment: {
    label: 'Devoir du prof',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  pass: { label: 'Passe actif', cls: 'bg-violet-50 text-violet-700 border-violet-200' },
  fundamental: { label: 'Gratuit', cls: 'bg-xp-50 text-xp-600 border-xp-100' },
  diagnostic: { label: 'Gratuit', cls: 'bg-xp-50 text-xp-600 border-xp-100' },
  no_access: { label: 'Verrouillé', cls: 'bg-ink-50 text-ink-400 border-ink-200' },
} as const;

interface Props {
  accessState: ExerciseAccessState;
  className?: string;
}

export function ExerciseAccessBadge({ accessState, className }: Props) {
  const meta = META[accessState.reason];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium',
        meta.cls,
        className,
      )}
    >
      {accessState.allowed ? null : <span>🔒</span>}
      {meta.label}
    </span>
  );
}
